import { BsStars } from 'react-icons/bs';

import { Flex, Text } from '@highlight-cp/core-ui';

const PoweredByHighlightAI = () => {
  return (
    <Flex align="center" c="var(--mantine-color-primary-text)" gap={4}>
      <BsStars size={14} />
      <Text size="xs">
        Powered by <strong>Highlight AI</strong>
      </Text>
    </Flex>
  );
};

export default PoweredByHighlightAI;
